import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { clientConfig } from '../../../config';
import * as translator from '../../../utils/translator';
import logo_v2025 from '../../../images/logo_v2025.png';
import LanguageToggle from '../HeaderCMS/LanguageToggle';

interface LoginPageHeaderProps {
  breadcrumbLabel: string;
}

const LoginPageHeader: React.FC<LoginPageHeaderProps> = ({ breadcrumbLabel }) => {
  const {country} = useParams();
  const navigate = useNavigate();
  const language = translator.getLanguageByCountry(country);
  const homeUrlPrefix = translator.getCMSUrlPrefixByLocale(translator.getLocaleByCountry(country));

  return (
    <header className=" md:px-[30px] md:py-[20px] md:py-[25px] bg-[#ffffff]">
      {/* Desktop: logo centered, breadcrumbs on the left in the same row */}
      <div className="hidden md:grid grid-cols-3 items-center ">
        {/* Breadcrumb navigation - left */}
        <div className="flex items-center gap-[8px]">
          <span className="text-[14px] font-poppins text-[#999999] cursor-pointer" onClick={() => navigate(-1)}>{translator.translate(language, "authentication", 'header/back')}</span>
          <span className="text-[14px] font-poppins text-[#999999]">/</span>
          <span className="text-[14px] font-poppins font-medium linear-text-color-primary">{breadcrumbLabel}</span>
        </div>

        {/* Logo - center */}
        <div
          className="flex justify-center cursor-pointer"
          onClick={() => (window.location.href = clientConfig.MAIN_WEBSITE_URL + "/" + homeUrlPrefix)}
        >
          <img
            src={logo_v2025}
            alt="DoktorABC"
            className="h-[28px] w-[171px]"
          />
        </div>

        <div className="flex justify-end">
          <LanguageToggle country={country ?? ''} language={language} />
        </div>
      </div>

      {/* Mobile: logo centered on first row, breadcrumbs left-aligned on second row */}
      <div className="flex flex-col md:hidden gap-[12px]">
        <div className="flex items-center bg-[#f6f7f980] py-[20px] px-[16px]">
          <div
            className="mx-auto flex justify-center cursor-pointer"
            onClick={() => (window.location.href = clientConfig.MAIN_WEBSITE_URL + "/" + homeUrlPrefix)}
          >
            <img
              src={logo_v2025}
              alt="DoktorABC"
              className="h-[21px] w-[128px]"
            />
          </div>
          <div className="shrink-0">
            <LanguageToggle country={country ?? ''} language={language} />
          </div>
        </div>

        <div className="flex items-center gap-[8px] px-[16px]">
          <span className="text-[14px] font-poppins text-[#999999] cursor-pointer underline" onClick={() => navigate(-1)}>{translator.translate(language, "authentication", 'header/back')}</span>
          <span className="text-[14px] font-poppins text-[#999999]">/</span>
          <span className="text-[14px] font-poppins font-medium linear-text-color-primary">{breadcrumbLabel}</span>
        </div>
      </div>
    </header>
  );
};

export default LoginPageHeader;
